import React from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "./index.css";
import App from "./App";

// 12/08/2026 - Antes esto era `registerServiceWorker()`. Ahora se hace lo
// contrario: dar de baja el que los usuarios ya tengan instalado. El motivo
// está explicado en limpiarServiceWorker.js.
import limpiarServiceWorker from './limpiarServiceWorker';

ReactDOM.render( <App /> , document.getElementById('root'));

limpiarServiceWorker();
